<app-header *ngIf="url != '/404'"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="url != '/404'"></app-footer>
